import React from 'react'
import ReCAPTCHA from 'react-google-recaptcha'

import { useRecaptcha } from './recaptcha'

const GoogleRecaptcha = () => {
  const { recaptchaRef, onChange } = useRecaptcha()

  return (
    <ReCAPTCHA
      badge="inline"
      onChange={() => onChange?.()}
      ref={recaptchaRef}
      sitekey={process.env.GATSBY_GOOGLE_CAPTCHA_SECRET_KEY}
      size="invisible"
    />
  )
}

export default GoogleRecaptcha
